import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@components/ui/Button';
import {
  denyConsent,
  getStoredConsent,
  grantConsent,
} from '@lib/posthog';

/**
 * KVKK çerez onay banner'ı.
 *
 * - localStorage'da `zoprey_analytics_consent` boşsa görünür.
 * - "Kabul Et" → analytics opt-in (PostHog event'leri başlar)
 * - "Sadece Zorunlu" → opt-out (PostHog event göndermez)
 * - "Detaylar" → /kvkk sayfası
 *
 * Bir kez karar verildiğinde banner kalıcı olarak gizlenir.
 * Kullanıcı sonradan kararı değiştirmek isterse Ayarlar > Gizlilik üzerinden.
 */
export function CookieConsentBanner() {
  // SSR yok ama defansif — ilk render'da localStorage erişimi ertelendi.
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getStoredConsent();
    if (consent === null) setVisible(true);
  }, []);

  if (!visible) return null;

  const accept = () => {
    // PostHog dynamic import + init burada tetiklenir (async, await etmiyoruz —
    // banner kapansın diye). Event akışı 1-2 sn sonra başlar.
    void grantConsent();
    setVisible(false);
  };

  const reject = () => {
    denyConsent();
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Çerez tercihleri"
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background/95 px-4 py-4 shadow-lg backdrop-blur supports-[backdrop-filter]:bg-background/80 md:px-6"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <p className="text-sm text-muted-foreground">
          Zoprey, ürünü iyileştirmek için anonim kullanım istatistikleri
          toplar (sayfa görüntüleme, tıklama sayısı, hata oranı). Bu veriler
          Avrupa Birliği'nde (Frankfurt) tutulur ve üçüncü taraflarla
          paylaşılmaz.{' '}
          <Link
            to="/kvkk"
            className="font-medium text-primary underline-offset-4 hover:underline"
          >
            Detaylı bilgi
          </Link>
        </p>
        <div className="flex shrink-0 gap-2">
          <Button variant="outline" size="sm" onClick={reject}>
            Sadece Zorunlu
          </Button>
          <Button size="sm" onClick={accept}>
            Kabul Et
          </Button>
        </div>
      </div>
    </div>
  );
}
